import { memo } from "react";
import { useTable } from "react-table";

interface ITable {
  columns: any;
  data: any;
  className?: string;
}

const Table = ({ columns, data, className }: ITable) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return (
    <div className={rows?.length >= 1 ? `${className} overflow-x-scroll` : ""}>
      <table {...getTableProps()} style={{ width: "100%" }}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              key={headerGroup.getHeaderGroupProps().key}
              style={{
                background: "var(--purple200)",
                color: "var( --primaryPurpleMain)",
              }}
            >
              {headerGroup.headers.map((column) => (
                <th className="px-2 py-2 text-sm" {...column.getHeaderProps()}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="text-sm leading-10" {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length === 0 && (
        <div className="mt-5 w-full text-center text-xl text-gray-300">
          {" "}
          No Records available{" "}
        </div>
      )}
    </div>
  );
};

export default memo(Table);
